import { For, Show } from "solid-js"

type StatItem = {
  label: string
  value: string
  change: string
  trend: "up" | "down"
}

// KPI cards. Picks up the active plugin accent from the `--oa-plugin-accent`
// CSS var (set on the canvas shell), with a graceful fallback, so the metric
// number and hover glow match the plugin's color.
export function StatWidget(props: { data: StatItem[] }) {
  return (
    <div data-dashboard-stat-widget="" class="grid auto-rows-fr grid-cols-2 gap-3 xl:grid-cols-4">
      <For each={props.data}>
        {(item) => (
          <div
            data-dashboard-stat-item=""
            class="oa-stat-card relative flex h-full min-w-0 flex-col gap-2 overflow-hidden rounded-2xl border border-border-weak-base bg-gradient-to-br from-background-base to-background-secondary/50 p-4 transition-all duration-200 hover:-translate-y-0.5 hover:border-border-base hover:shadow-[0_12px_34px_-16px_rgba(15,23,42,0.35)]"
          >
            {/* accent glow — visible ONLY on hover (see .oa-stat-glow in index.css) */}
            <div
              aria-hidden="true"
              class="oa-stat-glow pointer-events-none absolute -right-8 -top-8 size-24 rounded-full blur-2xl"
              style={{ background: "color-mix(in srgb, var(--oa-plugin-accent, #6366f1) 30%, transparent)" }}
            />
            <span
              class="relative z-10 truncate text-[11px] font-semibold uppercase tracking-[0.08em] text-text-dimmed"
              title={item.label}
            >
              {item.label}
            </span>
            <span
              class="relative z-10 truncate text-[32px] font-semibold leading-none tabular-nums text-text-strong"
              title={item.value}
            >
              {item.value}
            </span>
            <Show when={item.change}>
              <span
                title={item.change}
                classList={{
                  "relative z-10 inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium": true,
                  "bg-[color-mix(in_srgb,var(--color-text-success,#16a34a)_14%,transparent)] text-text-success":
                    item.trend === "up",
                  "bg-[color-mix(in_srgb,var(--color-text-danger,#dc2626)_14%,transparent)] text-text-danger":
                    item.trend === "down",
                }}
              >
                <span aria-hidden="true">{item.trend === "up" ? "▲" : "▼"}</span>
                {item.change}
              </span>
            </Show>
          </div>
        )}
      </For>
    </div>
  )
}
